import React, { useRef } from "react"

interface Props {
  onSkipForwards: VoidFunction
  onSkipBackwards: VoidFunction
}

export const Frame: React.FC<Props> = (props) => {
  const { onSkipBackwards, onSkipForwards } = props
  const backRef = useRef<HTMLButtonElement>(null)
  const forwardRef = useRef<HTMLButtonElement>(null)

  const backClicked = () => {
    backRef.current?.blur()
    onSkipBackwards()
  }

  const forwardClicked = () => {
    forwardRef.current?.blur()
    onSkipForwards()
  }
  return (
    <div
      style={{
        backgroundColor: "#000000",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ position: "relative" }}>
        <div
          style={{
            width: 740,
            marginTop: 36,
            height: 600,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {props.children}
        </div>
        <button
          ref={backRef}
          onClick={backClicked}
          style={{
            position: "absolute",
            backgroundColor: "rgb(0,0,0,0)",
            height: 50,
            width: 25,
            top: 530,
            left: 10,
          }}
        />
        <button
          ref={forwardRef}
          onClick={forwardClicked}
          style={{
            position: "absolute",
            backgroundColor: "rgb(0,0,0,0)",
            height: 50,
            width: 25,
            top: 530,
            right: 10,
          }}
        />
      </div>
    </div>
  )
}
